import { useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import {
  apiUrl,
  mfUrl,
  stripePubKey,
  tapPaymentPubKey,
  tapPaymentMerchantId,
  tapMerchantDomain,
} from '../../config/constants';
import { useLocalizationContext } from '../../contexts/localizationContext';
import RemoteComponentRuntime from '../../components/remote-component';
import { TPaypageProps } from '../../types/mf';
import { captureClickIds } from '../../lib/click-ids';

const config = {
  scope: 'mfComponent',
  module: 'Paypage',
  url: `${mfUrl}remoteEntry.js`,
};

// Both processor key sets are passed unconditionally: the MF decides which tiles
// to render (Tap vs Stripe) from the payment record's paymentOption.
const CustomPayment = () => {
  const params = useParams();
  const { language, currency } = useLocalizationContext();

  useEffect(() => {
    // Best-effort Google Ads click-id capture; only finds cookies on brand-domain paypages
    params.guid && captureClickIds(params.guid, 'payment');
  }, [params.guid]);

  return (
    <div className="container">
      <RemoteComponentRuntime<TPaypageProps>
        {...config}
        apiUrl={apiUrl}
        tapPubKey={tapPaymentPubKey}
        tapMerchantId={tapPaymentMerchantId}
        tapMerchantDomain={tapMerchantDomain}
        stripePubKey={stripePubKey}
        currencyCode={currency}
        languageCode={language}
        guid={params.guid || ''}
        customLoader={
          <div className="mf-container">
            <div
              className="flex justify-center items-center"
              style={{ width: '100vw', maxWidth: '100%', height: 200 }}
            ></div>
          </div>
        }
      />
    </div>
  );
};
export default CustomPayment;
